@if (loaded()) {
  @if (products().length > 0) {
    <ct-lib-radio-card-group
      orientation="vertical"
      [value]="selectedPriceId()"
      (valueChange)="selectedPriceId.set($event)"
    >
      @for (product of products(); track product.id) {
        <ct-lib-radio-card
          [value]="product.id"
          [label]="productTitle(product)"
          [price]="
            monthlyDisplayAmount(product)
              | currency: product.currency.toUpperCase() : 'symbol' : '1.0-0'
          "
          [priceHint]="periodHint(product)"
          [disabled]="disabled() || isUnavailable(product)"
        >
          @if (isCurrent(product)) {
            <ct-lib-tag radioCardBadge>{{
              'company-tool.snippets.ats-addon-booking-modal.current-badge'
                | transloco
            }}</ct-lib-tag>
          } @else if (isUnavailable(product)) {
            <ct-lib-tag radioCardBadge>{{
              'company-tool.snippets.ats-addon-booking-modal.unavailable-badge'
                | transloco
            }}</ct-lib-tag>
          }
        </ct-lib-radio-card>
      }
    </ct-lib-radio-card-group>
  } @else {
    <p class="empty-state">
      {{ 'company-tool.snippets.ats-addon-booking-modal.empty' | transloco }}
    </p>
  }
} @else {
  <div class="loading-wrapper">
    <ngx-skeleton-loader
      appearance="line"
      [theme]="{
        height: '88px',
        width: '100%',
        'border-radius': '15px',
      }"
      count="1"
      [animation]="
        themingService.theme === 'dark' ? 'progress-dark' : 'progress'
      "
    ></ngx-skeleton-loader>
  </div>
}
